export default "__VITE_ASSET__CvcfdWUM__ 148w, __VITE_ASSET__PaGfbjn6__ 296w, __VITE_ASSET__Bbitky6L__ 444w";